import React, { useEffect, useState, useRef, memo} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import TextField from '@mui/material/TextField';

import _ from 'lodash';

import { loadSettings, loadSuburbs } from '../actions';

const SuburbSelector = memo(({id, value, error, message, handleChange, setSuburb, label, required}) => {
	const dispatch = useDispatch();
	const memberSettings = useSelector(state => state.settings.members.data);
	const suburbs = useSelector(state => state.suburbs.data);
	const fetchingSuburbs = useSelector(state => state.suburbs.fetching);
	
	useEffect(() => {
		dispatch(loadSettings('members'));
	}, [dispatch])
	
	useEffect(() => {
		if(memberSettings.default_state !== '' && !fetchingSuburbs){
			dispatch(loadSuburbs(memberSettings.default_state));
		}
	}, [memberSettings, dispatch, fetchingSuburbs])
	
	const [filteredSuburbs, setFilteredSuburbs] = useState([]);
	const [keyword, setKeyword] = useState(value);
	
	let inputRef = useRef(null)
	
	// we only want to run this when keyword changes. No other dependencies.
	useEffect(() => {
		if(value !== keyword){
			if(keyword.length < 3){
				setFilteredSuburbs([]);
			} else {
				const upperKey = _.toUpper(keyword);
				const filtered = _.filter(suburbs, (s) => {
					return s.suburb.includes(upperKey);
				});
				setFilteredSuburbs(filtered);
			}
			handleChange(id, keyword);
		} // eslint-disable-next-line
	}, [keyword])

	return (
		<>
		<TextField
			variant="outlined"
			fullWidth
			error={error}
			helperText={message}
			onChange={(event) => setKeyword(event.target.value)}
			value={value}
			ref={inputRef}
			label={label}
			required={required}
		/>
		<Popper id='suburb_popper' 
			open={keyword.length > 3 && filteredSuburbs.length > 0} 
			anchorEl={inputRef.current}
			disablePortal={true}
			modifiers={[]}
		>
		<Paper elevation={2}>
		<ClickAwayListener onClickAway={() => setFilteredSuburbs([])}>
		<MenuList>
		{filteredSuburbs.map((s, i) => (
			<MenuItem key={i} onClick={() => {
				setFilteredSuburbs([]);
				setSuburb(s);
			}}>
				{s.suburb} {s.postcode}
			</MenuItem>
		))}
		</MenuList>
		</ClickAwayListener>
		</Paper>
		</Popper>
		</>
)});

export default SuburbSelector;